// export const PHONE = "07280637";
export const PHONE = "+44 1 623325085";
export const ADDRESS = "7-11 Douglas Street, Peel, Isle of Man, IM5 1BA";
export const PRACTICES = [
  {
    url: "family-law",
    title: "Family Law",
    sections: [
      {
        subtitle: "Prenuptial Agreement",
        text: "A prenuptial agreement is a contract entered into by a couple before marriage to determine the division of assets and property in the event of a divorce, including spousal support. Our experienced team is here to guide you through the process of drafting a prenuptial agreement that meets your needs and protects your interests.",
      },
      {
        subtitle: "Domestic Violence",
        text: "Our team of lawyers specializes in domestic violence and is dedicated to helping you find safety and lasting solutions. We can help you secure protective orders to stop further abuse, whether physical or emotional, and ensure your well-being throughout the process.",
      },
      {
        subtitle: "Legal Separation",
        text: "Legal separation is the formal process where the court recognizes a couple as legally separated, though the marriage remains intact. This option allows you to live separately without dissolving the marriage. We will help you understand the details of legal separation and what it means for your future.",
      },
      {
        subtitle: "Annulment",
        text: "An annulment is a legal ruling that your marriage was never valid, restoring both parties to their status before the marriage. Our expert family law team will assess if annulment is appropriate for you and provide guidance throughout the legal process.",
      },
      {
        subtitle: "Divorce",
        text: "Our team of family law professionals will help you navigate the complexities of divorce, including matters related to your children, assets, and financial considerations. As members of Resolution, we offer thoughtful and practical advice, always putting your and your family’s best interests first.",
      },
      {
        subtitle: "Child Custody",
        text: "In the event of divorce, our team will provide expert guidance on all aspects of child custody. We will help you determine where your child will live, who will have decision-making authority, and how parenting time will be arranged to ensure the best outcome for your child’s future.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "personal-injury",
    title: "Personal Injury",
    sections: [
      {
        subtitle: "Holiday & Accident Claims Abroad",
        text: "Whether you’ve had an accident while traveling abroad, on a package holiday, or on a business trip, we offer experienced advice on pursuing claims for injuries resulting from road accidents, air travel, sea incidents, or faulty hotel equipment. Our goal is to make the claims process as easy as possible for you.",
      },
      {
        subtitle: "Carbon Monoxide Poisoning Compensation",
        text: "If you believe you’ve been exposed to carbon monoxide, our personal injury specialists are ready to explain your legal options and assist you in pursuing a seamless claim. We ensure your case is handled with the utmost care, seeking the compensation you deserve.",
      },
      {
        subtitle: "Industrial Illness & Injury Claims",
        text: "Our team provides expert support for workers who have developed illnesses such as industrial deafness, dermatitis, asthma, or repetitive strain injuries due to their working conditions. We’ll guide you through the legal process to secure the compensation you're entitled to.",
      },
      {
        subtitle: "Product Injury Claims",
        text: "Injuries caused by defective products can have serious consequences. Our personal injury experts will help you make a claim, whether the product was bought in a store or online, ensuring you are compensated fairly for your injuries.",
      },
      {
        subtitle: "Road Traffic Injury Claims",
        text: "If you’ve been injured in a road traffic accident, we’ll help you seek damages for medical costs, lost wages, and pain and suffering. Our legal team will support you throughout the claims process, working to secure the best possible outcome for you.",
      },
      {
        subtitle: "Claims for Workplace Accidents",
        text: "If you’ve suffered an injury at work due to safety violations or negligence, you could be entitled to compensation. We specialize in handling cases involving falls, faulty equipment, or accidents caused by the actions of colleagues or supervisors.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "commercial-law",
    title: "Commercial Law",
    sections: [
      {
        subtitle: "Commercial Law",
        text: "We are dedicated to providing strategic legal advice to sole traders, owner-managed businesses, and both private and public limited companies. Our services cover a broad range of commercial law topics, including:",
      },
      {
        subtitle: "Acquisitions and Sales of Businesses/Assets",
        text: "",
      },
      {
        subtitle: "Mergers & Acquisitions",
        text: "",
      },
      {
        subtitle: "Commercial Contracts",
        text: "",
      },
      {
        subtitle: "Joint Ventures and Partnerships",
        text: "",
      },
      {
        subtitle: "Crowdfunding",
        text: "",
      },
      {
        subtitle: "Non-Disclosure Agreements",
        text: "",
      },
      {
        subtitle: "E-commerce Regulation",
        text: "",
      },
      {
        subtitle: "Franchising (for franchisors and franchisees)",
        text: "",
      },
      {
        subtitle: "Startups in Technology and App Development",
        text: "",
      },
      {
        subtitle: "Licensing",
        text: "",
      },
      {
        subtitle: "Company Law",
        text: "Our company law services encompass all areas of corporate governance and business law, offering guidance on:",
      },
      {
        subtitle: "Directors’ Duties and Responsibilities",
        text: "",
      },
      {
        subtitle: "Service Contracts",
        text: "",
      },
      {
        subtitle: "Incorporation and Corporate Structure",
        text: "",
      },
      {
        subtitle: "Shareholders’ Agreements",
        text: "",
      },
      {
        subtitle: "Corporate Recovery & Insolvency",
        text: "Our advisors offer practical solutions for companies facing financial difficulties, advising on:",
      },
      {
        subtitle: "Administration Processes",
        text: "",
      },
      {
        subtitle: "Company Voluntary Arrangements (CVAs)",
        text: "",
      },
      {
        subtitle: "Liquidation and Receivership",
        text: "We also assist creditors in navigating insolvency issues.",
      },
      {
        subtitle: "Charities",
        text: "Charities must adhere to strict regulatory standards. We provide expert advice to ensure compliance with these requirements, including:",
      },
      {
        subtitle: "Navigating Charity Commission registration",
        text: "",
      },
      {
        subtitle: "Drafting customized charity constitutions",
        text: "",
      },
      {
        subtitle: "Management and operational advice",
        text: "",
      },
      {
        subtitle: "Guidance for trustees on their roles and duties",
        text: "",
      },
      {
        subtitle: "Data Protection Law",
        text: "With the introduction of the UK GDPR, our team ensures that your business is fully compliant with the latest data protection laws. We work with organizations of all sizes, including not-for-profits and educational entities.",
      },
      {
        subtitle: "Healthcare Sector",
        text: "Our team offers specialized legal advice to those in the healthcare sector, including buyers, sellers, and owners of dental, medical, nursery, and nursing home businesses. We support your business throughout its growth and development, ensuring it remains legally secure.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "real-estate-law",
    title: "Real Estate Legal Services",
    sections: [
      {
        subtitle: "Auction Property",
        text: "Before committing to an auction purchase, our conveyancing team will carefully review the legal pack from the auctioneers and provide you with an in-depth report. This ensures you’re fully informed about the property and its legal standing, helping you make a confident decision.",
      },
      {
        subtitle: "Buying Property",
        text: "We ensure you’re fully aware of all relevant details about the property you're purchasing and its surroundings. Our team will also advise on the key aspects of your mortgage, including your loan terms and your obligations to the lender.",
      },
      {
        subtitle: "Selling Property",
        text: "With years of expertise in handling property sales, we streamline the process to ensure a smooth and swift transaction. After gathering essential information from you, we prepare a complete sale pack and send it to the buyer’s solicitors to begin the process without delay.",
      },
      {
        subtitle: "Leasing Property",
        text: "We assist with enfranchisement, enabling leaseholders to extend their lease or purchase the freehold of their property. This gives you greater control over management and security regarding property ownership.",
      },
      {
        subtitle: "Remortgaging",
        text: "We make remortgaging straightforward. From reviewing your mortgage offer and redeeming your existing loan to registering your new mortgage with the Land Registry, we handle every step efficiently and keep you updated along the way.",
      },
      {
        subtitle: "Shared Ownership",
        text: "As accredited members of The Law Society’s Conveyancing Quality Scheme, we specialize in Shared Ownership transactions, providing high-quality legal services recognized by industry standards.",
      },
      {
        subtitle: "Tenancy Agreements",
        text: "We offer comprehensive advice and draft tailored tenancy agreements for landlords and tenants, ensuring your rights and obligations are clear and legally protected.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "corporate-crime-and-risks",
    title: "Corporate Crime & Risk Solutions",
    sections: [
      {
        subtitle: "Commercial Fraud",
        text: "We offer comprehensive legal support for businesses and corporate officers in both pursuing and defending commercial fraud claims. With deep experience in defending clients against regulatory bodies like HM Revenue and Customs, the Serious Fraud Office, and the Financial Services Authority, our team ensures strategic protection.",
      },
      {
        subtitle: "Money Laundering",
        text: "Our expertise extends to advising businesses on compliance with the Money Laundering Regulations 2007 (as amended), as well as defending individuals and organizations under investigation for money laundering offenses.",
      },
      {
        subtitle: "VAT, Tax & Duty Fraud",
        text: "Tax, VAT, and duty fraud cases often involve a range of complex legal considerations. Our skilled criminal litigation team offers clear, concise case assessments, ensuring you have reliable guidance throughout your legal proceedings.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "employment-law",
    title: "Employment Law Expertise",
    sections: [
      {
        subtitle: "Employment Contracts",
        text: "Whether you're entering a new contract, trying to exit an existing one, or addressing potential breaches, our employment law team will break down the key terms and advise you on the best course of action.",
      },
      {
        subtitle: "Compromise Agreements",
        text: "In a compromise agreement, employees agree to accept a settlement in return for not pursuing any future legal claims against their employer. We can assess the fairness of such an agreement and negotiate to ensure the terms are in your favour.",
      },
      {
        subtitle: "Constructive Dismissal",
        text: "When an employer’s serious breach of contract forces you to resign, it may qualify as constructive dismissal. Our experienced team can offer expert guidance on whether your situation constitutes a valid claim and help you pursue compensation where appropriate..",
      },
      {
        subtitle: "Redundancy",
        text: "Employers must adhere to specific procedures when making positions redundant. If your employer fails to do so, you may have grounds for a claim of unfair dismissal. We can evaluate your case and guide you on securing potential compensation.",
      },
      {
        subtitle: "Discrimination",
        text: "If you’ve been subjected to workplace discrimination based on age, gender, race, religion, or any other protected characteristic, we provide expert advice on pursuing claims and offer full representation throughout any Tribunal proceedings.",
      },
      {
        subtitle: "Wrongful Termination / Unfair Dismissal",
        text: "If you’ve been dismissed unfairly, we’ll assess your case, outline your options for making a claim, and help you understand your potential for compensation. Our team can also assist you in bringing your case before an Employment Tribunal.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "civil-litigation",
    title: "Civil Litigation & Legal Services",
    sections: [
      {
        subtitle: "Dispute Resolution",
        text: "We deliver expert dispute resolution services across a range of areas, including Consumer, E-Commerce, and Contractual Disputes, as well as Partnership Disputes, Debt Recovery, Public Law, Judicial Reviews, and Director & Shareholder Disputes.",
      },
      {
        subtitle: "Wills, Inheritance & Probate",
        text: "We provide legal support for disputed wills and inheritance matters, including cases involving fraud, undue influence, and mental capacity issues, conflicts with Executors or Trustees, claims under the Inheritance (Provision for Family and Dependents) Act 1975, professional negligence related to will drafting, and disputes involving Power of Attorney.",
      },
      {
        subtitle: "Insolvency & Corporate Law",
        text: "We offer strategic advice to individuals and companies dealing with insolvency, including Bankruptcy, Liquidations, Company and Individual Voluntary Arrangements, Administrations, and Receiverships.",
      },
      {
        subtitle: "Media & Intellectual Property",
        text: "Our team advises clients on all aspects of media law, including defamation, libel, and slander, and provides guidance on Intellectual Property Law, covering copyrights, patents, trademarks, design rights, passing off protection, and safeguarding confidential information.",
      },
      {
        subtitle: "Negligence Claims",
        text: "We support clients in negligence claims from inception through to resolution, including Medical and Clinical Negligence and Professional Negligence cases.",
      },
      {
        subtitle: "Property & Land Disputes",
        text: "Our property litigation experts handle a wide range of issues involving both Leasehold and Freehold properties, including Adverse Possession Claims, Building Disputes, International and Domestic Property Litigation, Landlord-Tenant disputes, and Neighbor issues.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "estate-planning-wills-probate",
    title: "Comprehensive Estate Planning, Wills & Probate Services",
    sections: [
      {
        subtitle: "Asset Protection Planning",
        text: "Our service focuses on protecting your assets from creditors through strategic legal measures. We offer customized advice on various protection methods, including offshore solutions and trust structures tailored to your situation.",
      },
      {
        subtitle: "Power of Attorney",
        text: "By establishing a power of attorney, you grant another individual the authority to handle certain matters on your behalf, whether personal or business-related. We help you create documents that reflect your specific needs and provide guidance on any limitations to ensure your safety.",
      },
      {
        subtitle: "Probate and Estate Administration",
        text: "We assist with all aspects of estate administration, helping executors secure probate or letters of administration and manage the distribution of assets. Additionally, we offer expert advice on inheritance tax considerations.",
      },
      {
        subtitle: "Wills",
        text: "We create personalized wills that specify how your assets, including property, finances, and personal items, should be distributed after your passing. Without a will, the law dictates how your estate is divided.",
      },
      {
        subtitle: "Crypto Wills & Trusts",
        text: `If you own cryptocurrency, it's essential to include it in your estate plan. We specialize in drafting crypto-specific wills and trusts to ensure your digital assets are handled according to your wishes, preventing access issues and legal delays for your beneficiaries.`,
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "immigration",
    title: "Comprehensive Immigration Services",
    sections: [
      {
        subtitle: "Entry into the UK",
        text: "Whether you're looking to come to the UK as an entrepreneur, investor, visitor, skilled worker, or student, our immigration services cater to all. From entrepreneur and investor visas to family and sponsored skilled worker visas, as well as student visas and student visitor visas, we are here to help secure your entry to the UK.",
      },
      {
        subtitle: "Immigration Appeal",
        text: "If your visa or immigration status application has been refused, we offer expert assistance to challenge the decision and achieve a fair outcome. We handle cases involving administrative reviews, discretionary applications, human rights appeals, judicial reviews, and reconsideration appeals.",
      },
      {
        subtitle: "Representative of an Overseas Business (ROB) Visa",
        text: "The ROB visa, or Sole Representative Visa, enables overseas businesses to establish a UK branch or subsidiary. We provide guidance on the key requirements for this visa, as well as common reasons for refusal.",
      },
      {
        subtitle: "Returning Resident Visa",
        text: "If you hold Indefinite Leave to Remain (ILR) and have been outside the UK for over two years, you will need a Returning Resident visa to return and resume your life in the UK.",
      },
      {
        subtitle: "The British National (Overseas) BN(O) Visa",
        text: `The BN(O) visa allows individuals with British National (Overseas) status and their immediate family to enter and live in the UK. Explore more details on the BN(O) route through our dedicated Q&A page.`,
      },
      {
        subtitle: "Indefinite Leave to Remain (ILR) – 10-year long resident",
        text: `After living in the UK lawfully for 10 continuous years, you may be eligible to apply for Indefinite Leave to Remain. We explain the specific requirements and process for securing ILR based on long-term residence.`,
      },
      {
        subtitle: "Settling in the UK",
        text: `Our award-winning immigration team is dedicated to helping clients settle in the UK, from securing visa extensions and permanent residency to advising on citizenship applications.`,
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "banking-finance",
    title: "Banking & Finance.",
    sections: [
      {
        subtitle: "Loan Agreement & Debt Finance",
        text: "Our legal team specializes in providing tailored advice on a wide range of loan agreements and debt financing structures. We draft and negotiate custom loan and security agreements, crafted specifically to meet your business's needs, ensuring you are fully protected from the outset. We’ll guide you through every stage of the process for a secure, efficient outcome.",
      },
      {
        subtitle: "Project & Asset Based Finance",
        text: "Whether you're acquiring high-value assets, financing a new venture, or lending on asset-backed securities, our experts can offer in-depth legal insights into project and asset-based finance. We also create bespoke legal agreements, tailored to safeguard your interests and ensure clarity at each step.",
      },
      {
        subtitle: "Restructuring",
        text: "When financial challenges arise, restructuring can be a path to profitability and growth. Our team provides comprehensive advice on restructuring your business, including expert recommendations, compliance with directors' duties, and strategies for converting debt and equity. We also help resolve disputes early in the process, ensuring smoother transitions.",
      },
      {
        subtitle: "Shari’ah Compliant Finance",
        text: "We offer expert legal guidance on Shari’ah-compliant financing products, including Mudaraba, Musharaka, Murabaha, and Wakala. Our team delivers clear, client-focused advice to both lenders and borrowers, ensuring your transactions align with Shari’ah principles and meet your specific financing needs.",
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "blockchain-digital-assets",
    title: "Blockchain & Digital Assets.",
    sections: [
      {
        subtitle: "Legal Opinion",
        text: `Listing a token on a regulated crypto exchange often requires a formal legal opinion. This opinion confirms that the token has been thoroughly analyzed from a technical standpoint and that all related documentation is appropriately classified. Our team offers expert analysis of the token’s features and structure, evaluating the associated project and proposed sale to ensure full legal compliance and optimal protection for all stakeholders.`,
      },
      {
        subtitle: "Smart Contracts",
        text: `Smart contracts are programmable agreements that automate processes and eliminate intermediaries, helping to reduce overhead costs. Although easy to create, these contracts must be carefully constructed to avoid vulnerabilities. Our legal experts ensure that your smart contracts are both enforceable and robust, providing strategic guidance to achieve your business objectives while maintaining legal security for all parties involved..`,
      },
      {
        subtitle: "Tax & Regulation",
        text: `Handling taxes can be overwhelming, particularly for cryptocurrency traders unsure about their tax obligations. HMRC has made it clear that cryptocurrency gains are subject to taxation, requiring individuals and businesses to declare them accordingly. We offer expert assistance in preparing tax disclosures and provide strategic advice on managing your crypto assets in a tax-efficient manner, ensuring full regulatory compliance at all times.`,
      },
      {
        subtitle: "NFTs & Intellectual Property",
        text: `With our extensive expertise in Intellectual Property law, we’re well-versed in the growing intersection of IP and Non-Fungible Tokens (NFTs). Our team offers specialized services to help clients protect their NFT-related IP rights and resolve any disputes that may arise from NFT transactions, including the creation, sale, or purchase of NFTs.`,
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "commercial-litigation",
    title: "Commercial Litigation Expertise",
    sections: [
      {
        subtitle: "Disclaimer",
        text: `Our firm primarily advises clients with claims exceeding £15,000. Based on your circumstances, we can arrange a consultation or provide guidance on your next steps. Please submit your inquiry, and we’ll respond promptly.`,
      },
      {
        subtitle: "Dispute Resolution & Mediation",
        text: `While litigation is the last resort, we understand that court proceedings are sometimes necessary. Our team is adept at identifying the most suitable dispute resolution methods to help achieve favorable outcomes for your business.`,
      },
      {
        subtitle: "Debt Recovery",
        text: `We offer comprehensive debt recovery services to help your business recover outstanding amounts quickly and efficiently, utilizing various strategies. We also specialize in defending clients from unfair or unlawful debt collection practices.`,
      },
      {
        subtitle: "Commercial Insolvency",
        text: `If your business is facing insolvency, we provide expert advice on various options, including Administration, Liquidation, Company Voluntary Arrangements, and Receivership. We also guide creditors of insolvent companies through the process.`,
      },
      {
        subtitle: "Commercial Property",
        text: `We deliver expert legal advice and representation for Freeholders, Leaseholders, Landlords, and Tenants in commercial property disputes. Our team balances the legal, financial, and practical aspects of cases involving issues like Adverse Possession Claims and Forfeiture.`,
      },
      {
        subtitle: "Media & Intellectual Property",
        text: `Our team ensures your intellectual property is well-protected, whether you are dealing with a dispute or developing an innovative new idea. We advise on Copyright, Data Protection, Patents, Media Law, Trademarks, Reputation Management, and Design Rights.`,
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
  {
    url: "commercial-property",
    title: "Commercial Property Expertise",
    sections: [
      {
        subtitle: "Buying and Selling Commercial Properties",
        text: `For successful commercial property transactions, having an experienced solicitor by your side is crucial. Our team brings over 50 years of expertise, holding Law Society accreditation in property law and a recent nomination for "Conveyancer of the Year" at the Sunday Times EEA Awards. Whether the deal is straightforward or complex, we are dedicated to making the process as smooth as possible..`,
      },
      {
        subtitle: "Commercial Leases and Business Tenancy",
        text: `Our dedicated property team offers comprehensive support for both landlords and tenants. With leases often spanning 5, 10, or even 20+ years, precision and care are essential when negotiating the terms. We leverage our deep experience to guide you through each stage, ensuring your lease agreement meets your needs.`,
      },
      {
        subtitle: "Planning and Section 106 Matters",
        text: `Planning regulations in England can often seem overwhelming, but our team at Saracens excels at managing a wide range of planning matters. From small-scale applications to large-scale developments, including Section 106 agreements, we provide expert guidance from the very start to ensure your project is set up for success.`,
      },
    ],
    image:
      "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg",
  },
];
